import { useCallback } from 'react';

import * as Sentry from '@sentry/react';

import logger from 'js/app/loggerSingleton';

import type { GenericPreference } from 'bundles/naptimejs/resources/__generated__/UserPreferencesV1';
import { get, keyEnum, setOrUpdateGenericActivity } from 'bundles/user-preferences/lib/api';

const useTimestampDataFactory = (key: string) => {
  const getTimestamp = useCallback(
    () =>
      get(keyEnum.GENERIC)
        .then((preferences: GenericPreference) => {
          const { userActivityMap } = preferences;
          const returnableTimestamp: number | undefined = userActivityMap?.[key];

          return returnableTimestamp;
        })
        .catch((e) => {
          logger.error('Error retrieving last accessed timestamp.');
          Sentry.captureException(e, {
            extra: { message: `Error retrieving timestamp for key`, key },
          });

          return undefined;
        }),
    [key]
  );

  const setTimestamp = useCallback(
    () => setOrUpdateGenericActivity(key).catch(() => logger.error('Error setting or updating generic preference map')),
    [key]
  );

  return { getTimestamp, setTimestamp };
};

export default useTimestampDataFactory;
